module.exports = __webpack_public_path__ + "resources/emoji-c7a39969bcc10d60e30847d059ba5700.svg";